import { useParams } from 'react-router';
import { TabNav, type NavTab } from '@repo/ui/Tabs';
import { useUser } from '@repo/hooks/useUser';

import { POLICIES } from '@/lib/Authorization';

export type ApiKeyTab = 'overview' | 'numbers';

export const apiKeyTabPath = (accountId: string, apiKeyId: string, tab: ApiKeyTab = 'overview') =>
  `/a/${accountId}/develop/${apiKeyId}${tab === 'overview' ? '' : `/${tab}`}`;

const ApiKeyTabNav = () => {
  const { accountId = '', apiKeyId = '' } = useParams();
  const user = useUser();

  const tabs: (NavTab | null)[] = [
    { title: 'Overview', href: apiKeyTabPath(accountId, apiKeyId) },
    POLICIES['dids:index'](user)
      ? { title: 'Numbers', href: apiKeyTabPath(accountId, apiKeyId, 'numbers') }
      : null,
  ];

  return <TabNav tabs={tabs} />;
};

export default ApiKeyTabNav;
